export interface PaymentStatusOption {
  value: string;
  label: string;
  statusId?: number;
}

export interface PaymentLifecycleView {
  canonical_status?: string;
  allowed_status_actions?: string[];
  /** Legacy payment APIs return the display status but not canonical lifecycle fields. */
  status?: string;
}

export function paymentStatusLabel(row: PaymentLifecycleView, catalog: PaymentStatusOption[]): string {
  return (
    catalog.find(
      (item) =>
        item?.value != null && item.value === row.canonical_status,
    )?.label ??
    row.status ??
    "—"
  );
}

export function paymentStatusOptions(row: PaymentLifecycleView, catalog: PaymentStatusOption[]): PaymentStatusOption[] {
  // Do not treat missing legacy fields as a matching status.  Otherwise an old
  // API response (without `code` / `canonical_status`) creates options whose
  // values are undefined and can crash the dropdown while rendering.
  if (!row.canonical_status) return [];

  return catalog.filter(
    (item) =>
      item?.value != null &&
      (item.value === row.canonical_status ||
        row.allowed_status_actions?.includes(item.value)),
  );
}
